import { render } from "./VoucherEntry.vue?vue&type=template&id=37be244d&scoped=true"
import script from "./VoucherEntry.vue?vue&type=script&lang=js"
export * from "./VoucherEntry.vue?vue&type=script&lang=js"

import "./VoucherEntry.vue?vue&type=style&index=0&id=37be244d&scoped=true&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37be244d"]])

export default __exports__